// frontend/src/hooks/useLabourMarketSurvey.js
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { reportingAPI } from '../services/api';
import toast from '../utils/toast';

export const lmsQueryKey = (year, quarter) => (
  ['reports', 'labour-market-survey', { year, quarter }]
);

export const useLabourMarketSurvey = (year, quarter) => {
  return useQuery({
    queryKey: lmsQueryKey(year, quarter),
    queryFn: async () => {
      const response = await reportingAPI.getLabourMarketSurvey({ year, quarter });
      return response.data;
    },
    enabled: Boolean(year && quarter),
    staleTime: 60 * 1000,
  });
};

export const useSaveLabourMarketSurvey = (year, quarter) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ silent: _silent, ...payload } = {}) => reportingAPI.saveLabourMarketSurvey({
      year,
      quarter,
      ...payload,
    }),
    onSuccess: (response, payload) => {
      queryClient.setQueryData(lmsQueryKey(year, quarter), response.data);
      if (payload?.silent) return;
      if (payload?.declaration?.confirmed) {
        toast.success('Return declared. Copy the tables onto the MOM form.');
      } else if (payload?.education_attainments) {
        toast.success('Highest attainment confirmed for future LMS returns');
      } else {
        toast.success('LMS answers saved');
      }
    },
    onError: (error) => {
      const msg = error.response?.data?.error || 'Failed to save LMS answers';
      toast.error(typeof msg === 'string' ? msg : 'Failed to save LMS answers');
    },
  });
};
